import { fetchWrapper, objectToQueryParams } from '../utils';

export class admin {
  static baseUrl = process.env.REACT_APP_BASE_API + 'admin/users';

  static async createClient(form) {
    const url = `${this.baseUrl}/client`;
    return await fetchWrapper.post(url, form);
  }

  static async createOwner(form) {
    const url = `${this.baseUrl}/owner`;
    return await fetchWrapper.post(url, form);
  }

  static async createDriver(form) {
    const url = `${this.baseUrl}/driver`;
    return await fetchWrapper.post(url, form);
  }

  static async createModerator(form) {
    const url = `${this.baseUrl}/moderator`;
    return await fetchWrapper.post(url, form);
  }

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findOne(id) {
    const url = `${this.baseUrl}/${id}`;
    return await fetchWrapper.get(url);
  }

  static async getSelects(filters) {
    const url = `${this.baseUrl}/selects`;
    return await fetchWrapper.get(url);
  }

  static async updateClient(form) {
    const url = `${this.baseUrl}/client`;
    return await fetchWrapper.patch(url, form);
  }

  static async updateOwner(form) {
    const url = `${this.baseUrl}/owner`;
    return await fetchWrapper.patch(url, form);
  }

  static async updateDriver(form) {
    const url = `${this.baseUrl}/driver`;
    return await fetchWrapper.patch(url, form);
  }

  static async updateModerator(form) {
    const url = `${this.baseUrl}/moderator`;
    return await fetchWrapper.patch(url, form);
  }

  static async updateStatus(form) {
    const url = `${this.baseUrl}/status`;
    return await fetchWrapper.patch(url, form);
  }

  static async destroy(id) {
    return await fetchWrapper.delete(this.baseUrl, { id });
  }

  static async downloadDriverDetails(id) {
    const url = `${this.baseUrl}/driver/${id}/pdf`;
    return await fetchWrapper.get(url);
  }
}

export class moderator {
  static baseUrl = process.env.REACT_APP_BASE_API + 'moderator/reports/drivers';

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadAll(filters) {
    const url = `${this.baseUrl}/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadOne(id) {
    const url = `${this.baseUrl}/${id}/download`;
    return await fetchWrapper.get(url);
  }
}
